import * as React from "react";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/outline";
import { on } from "events";

interface IProps {
  prevArrowClassName: string;
  nextArrowClassName: string;
  onNextClick?: () => void;
  onPrevClick?: () => void;
  arrowColor?: string;
  buttonColor?: string;
  size?: "small" | "medium" | "large";
  mode?: "inset" | "outset";
}

const SliderNavigation = ({
  prevArrowClassName,
  nextArrowClassName,
  onNextClick,
  onPrevClick,
  arrowColor = "text-blue",
  buttonColor = "bg-white",
  size = "medium",
  mode = "outset",
}: IProps) => {
  const sizeClass = () => {
    switch (size) {
      case "small":
        return "w-7 h-7";
      case "medium":
        return "w-10 h-10";
      case "large":
        return "w-12 h-12";
      default:
        return "w-10 h-10";
    }
  };
  return (
    <>
      <div
        className={` slide-arrow ${prevArrowClassName} slidePrev-btn absolute z-[999] top-[calc(50%)] ${
          mode === "inset" ? "left-2 block" : "-left-12 hidden lg:block"
        }`}
        onClick={() => {
          if (onPrevClick) {
            onPrevClick();
          }
        }}
      >
        <div
          style={{
            filter: "drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.15))",
          }}
          className={` shadow-sm ${arrowColor} ${buttonColor}  hover:opacity-100 cursor-pointer ${sizeClass()} flex justify-center items-center rounded-full -mt-5`}
        >
          <ChevronLeftIcon className={mode === "inset" ? "w-7" : "w-7"} />
        </div>
      </div>
      <div
        className={`slide-arrow  ${nextArrowClassName} slideNext-btn absolute z-50 top-[calc(50%)] ${
          mode === "inset" ? "right-2 block" : "-right-12 hidden lg:block"
        }`}
        onClick={() => {
          if (onNextClick) {
            onNextClick();
          }
        }}
      >
        <div
          style={{
            filter: "drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.15))",
          }}
          className={`shadow-sm  ${arrowColor} ${buttonColor} hover:opacity-100 cursor-pointer  ${sizeClass()}  flex justify-center items-center rounded-full -mt-5`}
        >
          <ChevronRightIcon className={"w-7"} />
        </div>
      </div>
    </>
  );
};

export default SliderNavigation;
